module.exports = __webpack_public_path__ + "static/media/phone_newcommande.de959444.png";